import { useBlockValidation } from "../block-store";

/**
 * Hook for field-specific validation state and actions.
 * Provides a more ergonomic API for individual form fields.
 */
export const useBlockValidationField = (path: string) => {
  const validation = useBlockValidation();

  const error = validation.getFieldError(path);
  const warning = validation.getFieldWarning(path);
  const isValid = validation.isFieldValid(path);
  const hasWarning = validation.hasFieldWarning(path);
  const isTouched = validation.touchedFields.has(path);
  const shouldShowValidation = isTouched || validation.hasTriggeredSave;

  // Debug logging for validation state changes
  // Field validation state available for debugging if needed

  return {
    // Field-specific state
    error,
    warning,
    isValid,
    hasWarning,
    isTouched,

    // Computed state for UI
    shouldShowValidation,

    // Actions
    markAsTouched: () => {
      validation.markFieldAsTouched(path);
    },

    // Global validation state (for convenience)
    hasValidated: validation.hasValidated,
    hasTriggeredSave: validation.hasTriggeredSave,
  };
};
